export const getAnswerFeedbackData = (target, externalData) => {
  var _quizData$answers;
  const quizData = externalData;
  return quizData == null || (_quizData$answers = quizData.answers) == null ? void 0 : _quizData$answers[target];
};
//# sourceMappingURL=get-answers.js.map